import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { TargetToggle } from 'components/CampaignCreationWizard/VacancySelectStep/components/TargetToggle/TargetToggle';
import { VacancyListTab } from 'components/CampaignCreationWizard/VacancySelectStep/components/VacancyListTab/VacancyListTab';
import { WebsiteUrlTab } from 'components/CampaignCreationWizard/VacancySelectStep/components/WebsiteUrlTab/WebsiteUrlTab';

import { CampaignTarget, selectWizardCampaignTarget } from 'store/models/campaignCreationWizard';
import { useSelector } from 'store/utils';

export const VacancySelectStep: FC = () => {
    const campaignTarget = useSelector(selectWizardCampaignTarget);

    return (
        <>
            <TargetToggle />
            <VSpacing default={24} />
            {campaignTarget === CampaignTarget.Vacancy ? <VacancyListTab /> : <WebsiteUrlTab />}
        </>
    );
};
